(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    const headerMenuDetails = document.querySelectorAll('header-menu details');

  if (window.matchMedia('(hover: hover)').matches) {
    headerMenuDetails.forEach((details) => {
      if (details.dataset.hoverInit === 'true') return;
      details.dataset.hoverInit = 'true';

      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');

        // Replay the CSS open animation on every hover. The keyframe animation
        // (animateMenuOpen, fill-mode: forwards) only auto-restarts when the
        // element leaves/re-enters the render tree, which doesn't happen when we
        // just toggle [open] back-to-back — so cancel() + play() forces a fresh run.
        const submenu = details.querySelector(':scope > .header__submenu');
        if (submenu) {
          submenu.getAnimations().forEach((animation) => {
            animation.cancel();
            animation.play();
          });
        }
      });

      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
